module.exports = require("./es-BR");